import { render, staticRenderFns } from "./g-assistant-timeline.vue?vue&type=template&id=3e6d75be&scoped=true&"
import script from "./g-assistant-timeline.vue?vue&type=script&setup=true&lang=ts&"
export * from "./g-assistant-timeline.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./g-assistant-timeline.vue?vue&type=style&index=0&id=3e6d75be&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6d75be",
  null
  
)

export default component.exports